const markupForCollection = (collection, searchValue) => {
  var search_val = searchValue;

  var regex_val = new RegExp(search_val, 'is');

  var result_val = collection.data.title.replace(
    regex_val,
    '<b style="font-weight:700;">' + search_val + '</b>'
  );

  return `
    <div class="predictive__collection">
        <div class="predictive__collection__title">
            <a href="/collections/${collection.data.handle}">
                <h3>${result_val}</h3>
            </a>
        </div>
        </div>
    `;
};
const markupForProduct = (product, currency) => {
  return `
    <div class="predictive__product">
        <div class="predictive__product__image">
            <a href="${window.Shopify.routes.root}products/${product.data.handle}">
                <img style="    mix-blend-mode: multiply; filter: contrast(1);" loading="lazy" src="${
                  product.data.image
                    ? product.data.image
                    : product.data.image
                } "  alt="Image">
            </a>
        </div>
        <div class="predictive__product__info">
        <div class="predictive__product__title">
            <a href="${window.Shopify.routes.root}products/${product.data.handle}">
                <h3>${product.data.title}</h3>
            </a>
        </div>
        <div class="predictive__product__price">
            <span>${ product.data.vendor != 'AxxonSoft' && product.data.vendor != 'Xilica' && product.data.vendor != 'WatchGuard' ? product.data.price + currency : 'Inquire'}</span>
        </div>
        </div>
    </div>
    `;
};
const markupForSuggestion = (suggestion, searchValue) => {
  var search = searchValue;
  var regex = new RegExp(search, 'ig');
  var result = suggestion.replace(
    regex,
    '<b style="font-weight:700;">' + search + '</b>'
  );

  return `
    <div>
    <a href="/search?q=${suggestion}"> 
    ${result}
    </a> 
    </div>
    `;
};
const handleMarkup = (products, collections, suggestions, searchValue) => {
  const headerResult = document.querySelector('#header-search-results');
  const collectionArea = headerResult.querySelector('#collectionResults');
  const currency = document
    .querySelector('.header-container')
    .getAttribute('data-currency');
  collectionArea.innerHTML = '';

  collectionArea.insertAdjacentHTML(
    'beforeend',
    collections
      .map((collection) => {
        return markupForCollection(collection, searchValue);
      })
      .join('')
  );
  const productArea = headerResult.querySelector('#productResults');
  productArea.innerHTML = '';

  productArea.insertAdjacentHTML(
    'beforeend',
    products
      .map((product) => {
        return markupForProduct(product, currency);
      })
      .join('')
  );

  const suggestionArea = headerResult.querySelector('#suggestionResults');
  suggestionArea.innerHTML = '';

  suggestionArea.insertAdjacentHTML(
    'beforeend',
    suggestions
      .map((suggestion) => {
        return markupForSuggestion(suggestion, searchValue);
      })
      .join('')
  );
};

//get url language
function getLanguageFromUrl() {
  const url = window.location.href;
  const urlParts = url.split('/');
  const lastPart = urlParts[urlParts.length - 1];

  if (lastPart.includes('de')) return 'de';
  if (lastPart.includes('ar')) return 'ar';
  if (lastPart.includes('ja')) return 'ja';
  if (lastPart.includes('it')) return 'it';
  if (lastPart.includes('fr')) return 'fr';
  if (lastPart.includes('es')) return 'es';
  if (lastPart.includes('zh')) return 'zh';
  if (lastPart.includes('nl')) return 'nl';
  if (lastPart.includes('cz')) return 'cz';
  if (lastPart.includes('da')) return 'da';
  if (lastPart.includes('el')) return 'el';
  if (lastPart.includes('kz')) return 'kz';
  if (lastPart.includes('pt')) return 'pt';
  if (lastPart.includes('ro')) return 'ro';
  if (lastPart.includes('sv')) return 'sv';
  if (lastPart.includes('th')) return 'th';
  if (lastPart.includes('vi')) return 'vi';
  if (lastPart.includes('fi')) return 'fi';
  if (lastPart.includes('no')) return 'no';
  if (lastPart.includes('ko')) return 'ko';
  return 'default';
}

//get predictive engine name (elastic search)
function getPredictiveEngineName(baseEngineName, language) {
  switch (language) {
      case 'de':
          return baseEngineName + '-german';
      case 'ar':
          return baseEngineName + '-arabic';
      case 'ja':
          return baseEngineName + '-japanese';
      case 'it':
          return baseEngineName + '-italian';
      case 'fr':
          return baseEngineName + '-french';
      case 'es':
          return baseEngineName + '-spanish';
      case 'zh':
          return baseEngineName + '-chinese';
      case 'nl':
          return baseEngineName + '-dutch';
      case 'cz':
          return baseEngineName + '-czech';
      case 'da':
          return baseEngineName + '-danish';
      case 'el':
          return baseEngineName + '-greek';
      case 'kz':
          return baseEngineName + '-kazakh';
      case 'pt':
          return baseEngineName + '-portuguese';
      case 'ro':
          return baseEngineName + '-romanian';
      case 'sv':
          return baseEngineName + '-swedish';
      case 'th':
          return baseEngineName + '-thai';
      case 'vi':
          return baseEngineName + '-vietnamese';
      case 'fi':
          return baseEngineName + '-finnish';
      case 'no':
          return baseEngineName + '-norwegian';
      case 'ko':
          return baseEngineName + '-korean';
      default:
          return baseEngineName;
  }
}
//get collection engine name (elastic search)
function getCollectionEngineName(baseEngineName, language) {
  switch (language) {
      case 'de':
          return baseEngineName + '-german-engine';
      case 'fr':
          return baseEngineName + '-french-engine';
      case 'ar':
          return baseEngineName + '-arabic-engine';
      case 'ja':
          return baseEngineName + '-japanese-engine';
      case 'it':
          return baseEngineName + '-italian-engine';
      case 'es':
          return baseEngineName + '-spanish-engine';
      case 'zh':
          return baseEngineName + '-chinese-engine';
      case 'nl':
          return baseEngineName + '-dutch-engine';
      case 'cz':
          return baseEngineName + '-czech-engine';
      case 'da':
          return baseEngineName + '-danish-engine';
      case 'el':
          return baseEngineName + '-greek-engine';
      case 'kz':
          return baseEngineName + '-kazakh-engine';
      case 'pt':
          return baseEngineName + '-portuguese-engine';
      case 'ro':
          return baseEngineName + '-romanian-engine';
      case 'sv':
          return baseEngineName + '-swedish-engine';
      case 'th':
          return baseEngineName + '-thai-engine';
      case 'vi':
          return baseEngineName + '-vietnamese-engine';
      case 'fi':
          return baseEngineName + '-finnish-engine';
      case 'no':
          return baseEngineName + '-new-norwegian-engine';
      case 'ko':
          return baseEngineName + '-new-korean-engine';
      default:
      return baseEngineName + "-engine";
  }
}

//get data from elastic search (collections)
async function fetchDataPredictive(searchValue) {
  const language = getLanguageFromUrl();
  
  var clientPredictive = ElasticAppSearch.createClient({
    searchKey: 'search-5rbimazsc8rrj4yyektfmwoe',
    endpointBase: 'https://abloom-ai.ent.us-west1.gcp.cloud.es.io:9243',
    engineName: getPredictiveEngineName('abloom-ai-meta-total', language),
  });
  
  var clientCollection = ElasticAppSearch.createClient({
    searchKey: 'search-5rbimazsc8rrj4yyektfmwoe',
    endpointBase: 'https://abloom-ai.ent.us-west1.gcp.cloud.es.io:9243',
    engineName: getCollectionEngineName('abloom-ai-collections', language),
  });
  const options = {
    search_fields: {
      title: { weight: 10 },
    },
    page: { size: 7 },
  };
  const options2 = {
    search_fields: {
      title: { weight: 10 },
      vendor: { weight: 10 },
    },
    filters: { all: [{ status: 'ACTIVE' }] },
  };

  var suggestion = {
    size: 7,
    types: {
      documents: {
        fields: ['title', 'vendor'],
      },
    },
  };

  const queryText = searchValue;
  const filters = options2.filters;
  const functionUrl = "https://us-west1-fetchsome.cloudfunctions.net/function-searcai";
  const searchProducts = await fetch(functionUrl, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      queryText: queryText,
      filters: filters,
      page: 1,
      pageSize: 10,
      score: 0.1,
      language: language
    }),
  })
    .then((resultList) => {
      return resultList;
    })
    .catch((error) => {
      console.log(`error: ${error}`);
    });

  /*const searchProducts = await clientPredictive
    .search(searchValue, options2)
    .then((resultList) => {
      return resultList;
    })
    .catch((error) => {
      console.log(`error: ${error}`);
    });*/

  const filtersCollection = options.filters;
  const collectionFunctionUrl = "https://us-west1-fetchsome.cloudfunctions.net/function-searchai-collection";
  const searchCollections = await fetch(collectionFunctionUrl, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      queryText: queryText,
      filters: filtersCollection,
      page: 1,
      pageSize: 10,
      language: language,
    }),
  })
    .then((resultList) => {
      return resultList;
    })
    .catch((error) => {
      console.log(`error: ${error}`);
    });
    
  /*const searchCollections = await clientCollection
    .search(searchValue, options)
    .then((collections) => {
      return collections;
    })
    .catch((error) => {
      console.log(`error: ${error}`);
    });*/
  /*const searchSuggestion = clientPredictive
    .querySuggestion(searchValue, suggestion)
    .then((suggestion) => {
      return suggestion;
    })
    .catch((error) => {
      console.log(`error: ${error}`);
    });*/
    const suggestionFunctionUrl = "https://us-west1-fetchsome.cloudfunctions.net/function-searchai-suggestions";
    const searchSuggestion = await fetch(suggestionFunctionUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        queryText: queryText,
        page: 1,
        pageSize: 7,
        language: language,
      }),
    })
    .then((resultList) => {
        return resultList;
    })
    .catch((error) => {
        console.log(`error: ${error}`);
    });

  const allData = await Promise.all([
    searchProducts,
    searchCollections,
    searchSuggestion,
  ]);

  return allData;
}
async function searchGet(searchValue) {
  const skeleton = document.querySelectorAll('.skeleton-predictive');
  const headerResult = document.querySelector('#header-search-results');

  const isMobile = window.innerWidth <= 768;

  headerResult.style.display = isMobile ? 'flex' : 'grid';
  if (isMobile) {
    headerResult.style.flexDirection = 'column';
  }

  skeleton.forEach((element) => {
    element.style.display = isMobile ? 'flex' : 'grid';
    if (isMobile) {
      element.style.flexDirection = 'column';
    }
  });

  const collectionArea = headerResult.querySelector('#collectionResults');
  const productArea = headerResult.querySelector('#productResults');
  const suggestionArea = headerResult.querySelector('#suggestionResults');
  collectionArea.innerHTML = '';
  productArea.innerHTML = '';
  suggestionArea.innerHTML = '';

  try {
    const data = await fetchDataPredictive(searchValue);
    const dataFromFetch = await data[0].json();
    const transformedData = Array.isArray(dataFromFetch.hits?.hits) 
    ? dataFromFetch.hits.hits.map(hit => ({ data: hit._source }))
    : Array.isArray(dataFromFetch.hits) 
        ? dataFromFetch.hits.map(hit => ({ data: hit._source }))
        : [];
  
    const collectionDataFromFetch = await data[1].json();
    const transformedCollectionData = Array.isArray(collectionDataFromFetch.hits?.hits) 
    ? collectionDataFromFetch.hits.hits.map(hit => ({ data: hit._source }))
    : Array.isArray(collectionDataFromFetch.hits) 
        ? collectionDataFromFetch.hits.map(hit => ({ data: hit._source }))
        : [];
        
    const suggestionDataFromFetch = await data[2].json();

    skeleton.forEach((element) => {
      element.style.display = "none";
    });

    handleMarkup(
      transformedData,
      transformedCollectionData,
      suggestionDataFromFetch.suggestions,
      searchValue
    );
  } catch (error) {
    console.error(`SearchGet error: ${error}`);
  }
}

function AddListenerInputSearch() {
  const inputSearch = document.querySelector('#header-search');
  const headerResult = document.querySelector('#header-search-results');
  const predictiveWrapper = document.querySelectorAll('.predictiveWrapper');
  let timer = null;

  inputSearch.addEventListener('input', function (e) {
    clearTimeout(timer);
    timer = setTimeout(function () {
      if (e.target.value.trim().length === 0) {
        headerResult.style.display = 'none';
        return;
      } else {
        headerResult.style.display = window.innerWidth <= 768 ? 'flex' : 'grid';
      }

      if (window.innerWidth <= 768) {
        predictiveWrapper.forEach((el, index) => {
          el.style.display = index === 0 ? 'block' : 'none';
          
          const h1 = el.querySelector('h1');
          if (h1) {
            h1.style.display = 'none';
          }


        });
      } else {
        predictiveWrapper.forEach((el) => {
          el.style.display = 'block';
        });
      }

      searchGet(e.target.value);
    }, 600);
  });

  inputSearch.addEventListener('focusout', function (e) {
    setTimeout(function () {
      headerResult.style.display = 'none';
    }, 300);
  });

  const searchModalBtn = document.querySelector('#search-icon-btn');
  searchModalBtn.addEventListener('click', function (e) {
    inputSearch.classList.toggle('modal-search');
  });

  // const closePredictive = document.querySelector('.close-modal-search');
  // closePredictive.addEventListener('click', function (e) {
  //   e.preventDefault();
  //   inputSearch.classList.toggle('modal-search');
  // });
}



function predictiveInit() {
  AddListenerInputSearch();
}

document.addEventListener('DOMContentLoaded', predictiveInit);
